<template>
	<div>

		<headinfo></headinfo>

		<div class="center container">
			<div class="center-nav">
				<span class="hidden-xs">您的位置：</span>
				<router-link :to="{name:'home'}">首页</router-link><i>&gt;</i>
				<a title="机构设置" href="#">机构概况</a>
			</div>
			<div class="center-container">
				<div class="center-container-left">
					<div class="center-container-left-Ltitle">
						<ul>
							<li>
								<a class="active" title="本处简介" @click="show('1')">本处简介</a>
							</li>
							<li>
								<a class="active" title="组织架构" @click="show('2')">组织架构</a>
							</li>
							<li>
								<a class="active" title="领导致辞" @click="show('3')">领导致辞</a>
							</li>
						</ul>
						<div class="left-pic">
							<img src="../assets/img/left-pic.png" alt="">
						</div>
					</div>
				</div>

				<!-- 机构介绍 -->
				<div class="center-container-right" v-if="pages=='1'">
					<div class="center-container-right-title">
						<span class="title">本处简介</span>
					</div>
					<div class="center-container-right-words">
						<div v-html="content"></div>
					</div>
				</div>

				<!-- 组织架构 -->
				<div class="center-container-right" v-if="pages=='2'">
					<div class="center-container-right-title">
						<span class="title">组织架构</span>
					</div>
					<div class="zuzhi-img">
						<div v-html="content"></div>
					</div>
				</div>

				<!-- 领导致辞 -->
				<div class="center-container-right" v-if="pages=='3'">
					<div class="center-container-right-title">
						<span class="title">领导致辞</span>
					</div>
					<div class="center-container-right-words">
						<div style="line-height: 22px;padding: 30px 30px;" v-html="content"></div>
					</div>
				</div>

			</div>
		</div>
		<bottominfo></bottominfo>

	</div>
</template>

<script>
	import headinfo from '../components/headinfo.vue'
	import bottominfo from '../components/bottominfo.vue'
	import {
		getMechanism
	} from '../api/index.js'
	export default {
		name: "Bossspeak",
		components: {
			headinfo,
			bottominfo
		},
		metaInfo: {
			title: '机构概况-邯郸市诚信公证处',
			meta: [{
				name: 'keyWords',
				content: '公证处机构简介、组织架构、领导致辞'
			}],
		},
		data() {
			return {
				pages: '1',
				content: '',
			}
		},
		mounted() {
			this.listenPage();
		},
		created() {
			this.pages = this.$route.params.page;
			this.getinfo(this.pages);
		},
		methods: {
			show(row) {
				this.pages = row;
				this.getinfo(row);
			},
			listenPage() {
				window.onbeforeunload = function(e) {
					this.pages = '1';
				};
			},
			getinfo(row) {
				let types = '';
				if (row == '1') {
					types = "introduce"
				} else if (row == '2') {
					types = "framework"
				} else if (row == '3') {
					types = "address"
				}
				getMechanism({
					type: types
				}).then(res => {
					this.content = res.data.content;
				})
			}
		},
		// 监听路由
		watch: {
			$route: {
				handler: function(val, oldVal) {
					this.pages = val.params.page;
					this.getinfo(val.params.page);
				},
				// 深度观察监听
				deep: true
			}
		},
	}
</script>

<style>
	@import "../assets/css/reset.css";
	@import "../assets/css/new_file.css";
</style>
